import React, { useEffect, useState } from "react";
import axios from "axios";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MonthlyMagazineManager = () => {
  const [title, setTitle] = useState("");
  const [month, setMonth] = useState(
    months[new Date().getMonth()]
  );

  const [year, setYear] = useState(
    new Date().getFullYear()
  );

  const [pdf, setPdf] = useState(null);
  const [thumbnail, setThumbnail] =
    useState(null);

  const [loading, setLoading] =
    useState(false);

  const [magazines, setMagazines] =
    useState([]);

  const token =
    JSON.parse(localStorage.getItem("user"))
      ?.token;

const API_BASE =
  process.env.REACT_APP_API_URL ||

  "https://upsc-backend-353e.onrender.com";

  // =========================
  // Fetch Magazines
  // =========================
  const fetchMagazines = async () => {
    try {
      const res = await axios.get(
  `${API_BASE}/api/monthly-magazines/admin/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMagazines(res.data.magazines || []);
    } catch (error) {
      console.error(error);
    }
  };



  // =========================
  // Upload Magazine
  // =========================
  const handleUpload = async (e) => {
    e.preventDefault();

    if (!pdf || !thumbnail) {
      return alert(
        "PDF and thumbnail are required"
      );
    }

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("title", title);
      formData.append("month", month);
      formData.append("year", year);

      formData.append("pdf", pdf);
      formData.append(
        "thumbnail",
        thumbnail
      );      

await axios.post(
  `${API_BASE}/api/monthly-magazines/upload`,
        formData,
        {
          headers: {
  Authorization: `Bearer ${token}`,
},
        }
      );

      alert("Magazine uploaded successfully");

      setTitle("");
      setPdf(null);
      setThumbnail(null);

      fetchMagazines();
    } catch (error) {
      console.error(error);

      alert(
        error?.response?.data?.message ||
          "Upload failed"
      );
    } finally {
      setLoading(false);
    }
  };



  // =========================
  // Delete Magazine
  // =========================
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Delete this magazine?"
    );

    if (!confirmDelete) return;

    try {
      await axios.delete(
  `${API_BASE}/api/monthly-magazines/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      fetchMagazines();
    } catch (error) {
      console.error(error);
      alert("Delete failed");
    }
  };



  useEffect(() => {
    fetchMagazines();
  }, []);




  return (
    <div className="p-6 text-white">
      <h1 className="text-3xl font-bold mb-6">
        Monthly Magazine Manager
      </h1>

      {/* Upload Form */}
      <form
        onSubmit={handleUpload}
        className="bg-zinc-900 p-6 rounded-2xl mb-8 space-y-4"
      >
        <input
          type="text"
          placeholder="Magazine Title"
          value={title}
          onChange={(e) =>
            setTitle(e.target.value)
          }
          className="w-full p-3 rounded bg-zinc-800"
          required
        />

        <div className="grid md:grid-cols-2 gap-4">
          <select
            value={month}
            onChange={(e) =>
              setMonth(e.target.value)
            }
            className="p-3 rounded bg-zinc-800"
          >
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>

          <input
            type="number"
            value={year}
            onChange={(e) =>
              setYear(e.target.value)
            }
            className="p-3 rounded bg-zinc-800"
          />
        </div>

        <div className="space-y-3">
          <div>
            <p className="mb-1">
              Upload PDF
            </p>

            <input
              type="file"
              accept="application/pdf"
              onChange={(e) =>
                setPdf(e.target.files[0])
              }
              required
            />
          </div>

          <div>
            <p className="mb-1">
              Upload Thumbnail
            </p>

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setThumbnail(
                  e.target.files[0]
                )
              }
              required
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-xl font-semibold"
        >
          {loading
            ? "Uploading..."
            : "Upload Magazine"}
        </button>
      </form>



      {/* Magazine List */}
      <div className="grid md:grid-cols-3 gap-6">
        {Array.isArray(magazines) &&
  magazines.map((magazine) => (
          <div
            key={magazine._id}
            className="bg-zinc-900 rounded-2xl overflow-hidden"
          >
            <img
              src={magazine.thumbnail}
              alt={magazine.title}
              className="w-full h-60 object-cover"
            />

            <div className="p-4">
              <h2 className="font-bold text-lg">
                {magazine.title}
              </h2>

              <p className="text-gray-400 mt-1">
                {magazine.month}{" "}
                {magazine.year}
              </p>

              {magazine.isPremium && (
                <span className="inline-block mt-2 bg-yellow-500 text-black px-3 py-1 rounded-full text-sm font-bold">
                  Premium
                </span>
              )}

              <div className="flex gap-3 mt-4">
                <a
                  href={magazine.pdfUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="bg-green-600 px-4 py-2 rounded-lg"
                >
                  View PDF
                </a>

                <button
                  onClick={() =>
                    handleDelete(
                      magazine._id
                    )
                  }
                  className="bg-red-600 px-4 py-2 rounded-lg"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthlyMagazineManager;